import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

export const CompletedRequestsTable = ({ data }) => {
  return (
    <>
      {data && data.length ? (
        <TableContainer component={Paper}>
          <Table aria-label="Staff History Table">
            <TableHead>
              <TableRow>
                <TableCell>Invoice</TableCell>
                <TableCell>Shipment</TableCell>
                <TableCell>Shipment Date</TableCell>
                <TableCell>Reference</TableCell>
                <TableCell>Item</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Qty</TableCell>
                {/* <TableCell>Track</TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.map((line, index) => (
                <TableRow
                  key={line.docno + index}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {line.docno}
                  </TableCell>
                  <TableCell>{line.shipmentNo}</TableCell>
                  <TableCell>{line.shipmentDate}</TableCell>
                  <TableCell>{line.custReference}</TableCell>
                  <TableCell>{line.no}</TableCell>
                  <TableCell>{line.description}</TableCell>
                  <TableCell>{line.quantity}</TableCell>
                  {/* <TableCell>{line.consignmentNo}</TableCell> */}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <>No Data</>
      )}
    </>
  );
};
